<template>
  <v-app-bar
    elevation="4"
    class="header"
  >
    <v-toolbar-title style="cursor: pointer" @click="$router.push('/seminar')"><img class="mr-5" style="max-width: 80px;" src="@/assets/img/logo.png"></v-toolbar-title>
    <div class="d-none d-lg-flex">
      <div class="menu-item" @click="changeRoute('event-dashboard')" v-if="isAuthenticated">
        {{ $t('navigation.eventDashboard') }}
      </div>
      <div class="menu-item" @click="changeRoute('seminar')" v-if="isAuthenticated">
        {{ $t('navigation.event') }}
      </div>
      <div class="menu-item" @click="changeRoute('recherche')" v-if="isAuthenticated">
        {{ $t('navigation.recherche') }}
      </div>
      <div class="menu-item" @click="changeRoute('fundings')" v-if="isAuthenticated && checkAdmin(currentUser.mitarbeiterId)">
        {{ $t('navigation.fundings') }}
      </div>
      <div class="menu-item" @click="changeRoute('address-recherche')" v-if="isAuthenticated">
        {{ $t('navigation.address-search') }}
      </div>
      <div class="menu-item" @click="changeRoute('reportings')" v-if="isAuthenticated && checkAdmin(currentUser.mitarbeiterId)">
        {{ $t('navigation.reportings') }}
      </div>
    </div>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div class="d-block d-lg-none">
      <v-menu
        bottom
        left
        min-width="200px"
        rounded
        offset-y
        content-class="header-mobile-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <i class="fas fa-bars"></i>
          </v-btn>
        </template>
        <v-list>
          <v-list-item class="menu-item" @click="changeRoute('event-dashboard')" v-if="isAuthenticated">
            {{ $t('navigation.eventDashboard') }}
          </v-list-item>
          <v-list-item class="menu-item" @click="changeRoute('seminar')" v-if="isAuthenticated">
            {{ $t('navigation.event') }}
          </v-list-item>
          <v-list-item class="menu-item" @click="changeRoute('recherche')" v-if="isAuthenticated">
            {{ $t('navigation.recherche') }}
          </v-list-item>
          <v-list-item class="menu-item" @click="changeRoute('fundings')" v-if="isAuthenticated && checkAdmin(currentUser.mitarbeiterId)">
            {{ $t('navigation.fundings') }}
          </v-list-item>
          <v-list-item class="menu-item" @click="changeRoute('address-recherche')" v-if="isAuthenticated">
            {{ $t('navigation.address-search') }}
          </v-list-item>
          <v-list-item class="menu-item" @click="changeRoute('reportings')" v-if="isAuthenticated && checkAdmin(currentUser.mitarbeiterId)">
            {{ $t('navigation.reportings') }}
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-menu
      bottom
      left
      min-width="200px"
      rounded
      offset-y
      :close-on-content-click="false"
      content-class="header-account-menu"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          x-large
          v-on="on"
        >
          <v-avatar
            color="primary"
            size="48"
          >
            <span v-if="currentUser.firstName && currentUser.lastName" class="white--text text-h5">{{currentUser.firstName.charAt(0).toUpperCase()}}{{currentUser.lastName.charAt(0).toUpperCase()}}</span>
            <span v-else class="white--text text-h5"><v-icon size="28">mdi-account-circle</v-icon></span>
          </v-avatar>
        </v-btn>
      </template>
      <v-card class="pt-4">
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-center">
            <v-avatar
              color="primary"
              class="mb-2"
            >
              <span class="white--text text-h5">
                <span v-if="currentUser.firstName && currentUser.lastName" class="white--text text-h5">{{currentUser.firstName.charAt(0).toUpperCase()}}{{currentUser.lastName.charAt(0).toUpperCase()}}</span>
              </span>
            </v-avatar>
            <p class="text-caption mt-2">
              {{currentUser.firstName}} {{currentUser.lastName}}
            </p>
            <p class="text-caption">
              {{ version }}
            </p>
            <v-divider class="my-3"></v-divider>
            <v-btn
              depressed
              rounded
              text
              @click="onLogout"
            >
              Logout
            </v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import { mapState } from 'vuex'
  import { isEmpty } from 'lodash'
  import { isAdmin } from '@/helpers/auth.js'

  export default {
    data: () => ({
      version: ''
    }),
    created () {
      if ((this.isAuthenticated && isEmpty(this.currentUser.id))) {
        this.onLogout()
      }
      if (process.env.VUE_APP_VERSION) {
        this.version = process.env.VUE_APP_VERSION
      }
    },
    methods: {
      changeRoute (routeName) {
        this.$router.push({
          name: routeName
        })
      },
      async onLogout () {
        try {
          await this.$store.dispatch('user/LOGOUT')
        } catch (err) {
          console.error(err)
        }
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      ...mapState({
        isAuthenticated: state => state.user.isAuthenticated,
        currentUser: state => state.user.currentUser
      })
    }
  }
</script>
